/** Shared Recruitment & Training sidebar section — no allowedRoles (visible to all). */
export const recruitmentTrainingNavigationRoute = {
  name: 'recruitment-training',
  displayName: 'Recruitment & Training',
  meta: {
    icon: 'school',
  },
  children: [
    {
      name: 'recruiter-dashboard',
      displayName: 'Recruiter Dashboard',
      meta: {
        icon: 'person_add',
      },
    },
    {
      name: 'driver-training',
      displayName: 'Driver Training',
      meta: {
        icon: 'school',
      },
    },
    {
      name: 'training-types',
      displayName: 'Training Types',
      meta: {
        icon: 'category',
      },
    },
  ],
}
